module.exports = __webpack_public_path__ + "img/cp-ai-2.a0d10982.jpg";